/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popAirdropTask.vue?vue&type=template&id=64b3d2f8&scoped=true"
import script from "./popAirdropTask.vue?vue&type=script&lang=js"
export * from "./popAirdropTask.vue?vue&type=script&lang=js"
import style0 from "./popAirdropTask.vue?vue&type=style&index=0&id=64b3d2f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b3d2f8",
  null
  
)

export default component.exports